var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.topbar},[_c('div',{staticClass:"mr-md-4 mr-auto"},[_c('air-search')],1),_c('div',{staticClass:"mr-auto d-none d-md-block"}),_c('div',{},[_c('air-user-menu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }